import t from "./loadAmap.js";
import { __awaiter as n, __generator as i } from "./_virtual/_tslib.js";

function r(r) {
  return n(this, void 0, void 0, function () {
    var n;
    return i(this, function (i) {
      switch (i.label) {
        case 0:
          return [4, t()];

        case 1:
          return n = i.sent(), [2, new Promise(function (t) {
            n.plugin(r, function () {
              t(window.AMap);
            });
          })];
      }
    });
  });
}

export default r;